const BASE_INTERVAL = 60000; // 1 minute
const JITTER_RANGE = 8000; // ±8 seconds

export const getJitteredInterval = () => {
  const timestamp = Date.now();
  const performanceTime = performance.now();
  
  // Create a simple hash from timestamp and performance time for better distribution
  const combinedString = `${timestamp}${Math.floor(performanceTime * 1000)}`;
  const hash = combinedString.toString().split('').reduce((acc, char) => { 
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);
  
  const jitter = ((Math.abs(hash) % JITTER_RANGE) - JITTER_RANGE / 2);
  
  return BASE_INTERVAL + jitter;
};
